import callApi from '../../util/apiCaller';

import { setIsFetching } from '../App/AppActions';
import { addError } from '../Error/ErrorActions';

export const SET_SUBSCRIPTIONS = 'SET_SUBSCRIPTIONS';

const SUBSCRIPTIONS_FETCH_LIMIT = 1000;

export const SUBSCRIPTION_MIN_QUANTITY = 2;


// Requests
export function getSubscriptionsRequest(onlyFirstItems = false) {
    const recursiveFetch = (limit = SUBSCRIPTIONS_FETCH_LIMIT, start = 0, subscriptions = []) => {
        return new Promise((resolve, reject) => {
            return callApi(`subscriptions?start=${start}&limit=${limit}`).then(res => {
                if(res.subscriptions && res.subscriptions.length) {
                    return onlyFirstItems ? resolve(res.subscriptions) : resolve(recursiveFetch(limit, start + limit, subscriptions.concat(res.subscriptions)));
                }
                resolve(subscriptions);
            }).catch(err => {
                reject(err);
            });
        });
    };

    return dispatch => {
        dispatch(setIsFetching('subscriptions'));
        return recursiveFetch().then(subscriptions => {
            dispatch(setSubscriptions(subscriptions || []));
            return subscriptions;
        }).catch(err => {
            dispatch(addError(err));
        });
    };
}

export function getSubscriptionsByUserRequest(userId = null) {
    return dispatch => {
        return callApi(`subscriptions/user/${userId || ''}`).then(res => {
            res.subscriptions && dispatch(setSubscriptions(res.subscriptions));
            return res.subscriptions;
        }).catch(error => {
            dispatch(addError(error));
            return null;
        });
    };
}

export function getSubscriptionRequest(subscriptionId) {
    return dispatch => {
        return callApi(`subscription/${subscriptionId}`).then(res => {
            res.subscription && dispatch(setSubscriptions([res.subscription]));
            return res.subscriptions;
        }).catch(error => {
            // dispatch(addError(error));
            return null;
        });
    };
}

export function getSubscriptionPaypalPlanRequest(subscriptionId) {
    return dispatch => {
        return callApi(`subscription/paypal/plan/${subscriptionId}`).then(res => {
            return res.plan;
        }).catch(error => {
            // dispatch(addError(error));
            return null;
        });
    };
}

export function editSubscriptionRequest(subscription) {
    return dispatch => {
        return callApi('subscription/edit', 'post', { subscription }).then(res => {
            res.subscription && dispatch(getSubscriptionRequest(res.subscription._id));
            return res.subscription;
        }).catch(error => {
            // dispatch(addError(error));
            return null;
        });
    };
}

export function cancelSubscriptionRequest(subscriptionId) {
    return dispatch => {
        return callApi('subscription/cancel', 'post', { subscription: { _id: subscriptionId } }).then(res => {
            res.subscription && dispatch(getSubscriptionRequest(res.subscription._id));
            return res;
        }).catch(error => {
            // dispatch(addError(error));
            return null;
        });
    };
}


// GETTERS
export function getSubscriptions(store, statuses = null) {
    if(statuses && !Array.isArray(statuses)) {
        statuses = [statuses];
    }
    return store.subscriptions.data.filter(subscription => !statuses || statuses.includes(subscription.status));
}

export function getSubscriptionsByUser(store, userId, statuses = null) {
    return getSubscriptions(store, statuses).filter(subscription => !userId || getSubscriptionUserId(subscription) === userId);
}

export function getSubscription(store, subscriptionId) {
    return store.subscriptions.data.find(subscription => subscription._id === subscriptionId);
}

export function getSubscriptionUserId(subscription) {
    return subscription && subscription.user && subscription.user._id ? subscription.user._id : (subscription || {}).user;
}

export function getSubscriptionPeriods() {
    const periods = [
        {
            unit: 'month',
            value: 1,
        },
        {
            unit: 'week',
            value: 6,
        },
        {
            unit: 'month',
            value: 2,
        },
    ];
    if(process.env.NODE_ENV !== 'production') {
        periods.push({ unit: 'day', value: 1 });
    }
    return periods;
}

export function getSubscriptionStatuses() {
    return ['active', 'inactive'];
}

export function getSubscriptionStatusColor(status) {
    switch(status) {
        case 'active':
            return 'warning';

        case 'inactive':
        default:
            return 'secondary';
    }
}

export function getSubscriptionPaymentUnit(unit) {
    switch(unit) {
        case 'day':
            return 'd';

        case 'week':
            return 'ww';

        case 'month':
            return 'm';

        default:
            return '';
    }
}

// Actions
export function setSubscriptions(subscriptions) {
    return {
        type: SET_SUBSCRIPTIONS,
        subscriptions,
    };
}
